export default __webpack_public_path__ + "static/media/zip.0e4a45fd.svg";